import { timer } from '../../universal';
import { React, _ } from '../lib';
import { J2rButton } from './component-buttons';
import { j2r, reactFlyoutNew } from './component-react';
import { trionlineAjax } from './component-trionline';
import { Bindings } from './ui5';
let swRegistration = undefined;
let applicationServerKey = undefined;
let pushSubscription = undefined;
let pushSubUploadRequired = false;
let swReady = false;
const swlog = (s, warning) => {
    let css1, css2;
    if (warning) {
        css1 = 'color:#88f';
        css2 = 'color:#f00';
    }
    else {
        css1 = 'color:#88f';
        css2 = 'color:#888';
    }
    console.log(`%c[SW] %c${s}`, css1, css2);
};
export const registerServiceWorker = async () => {
    if (navigator.serviceWorker == null) {
        console.warn('Service workers not available');
        return undefined;
    }
    if (window.PushManager == null) {
        console.warn('Push messaging is not supported');
    }
    const url = '/sw-trionline';
    const options = { scope: '/' };
    const sw = await navigator.serviceWorker.register(url, options);
    swlog('Service worker registered, waiting...');
    swRegistration = sw;
    timer(2000, () => {
        if (!swReady) {
            console.warn(`There seems to be an issue connecting to the service worker for TriOnline. Some features may not work properly until this is resolved. Please try closing all open TriOnline tabs and re-opening TriOnline.`);
        }
    });
    await navigator.serviceWorker.ready;
    swReady = true;
    if (navigator.serviceWorker.controller != null) {
        swlog('Service worker is ready!');
    }
    else {
        swlog('Service worker DISABLED - probably by a browser hard refresh');
    }
    await askPermissionNotifications();
    const prmGetSub = getSubscription();
    const prmGetAppKey = getApplicationServerKey();
    await Promise.all([prmGetSub, prmGetAppKey]);
    pushSubscription = await prmGetSub;
    applicationServerKey = await prmGetAppKey;
    if (Notification.permission === 'denied') {
        const txt = 'Warning: notification permission denied - push disabled';
        swlog(txt, Notification.permission === 'denied');
    }
    else {
        swlog('Fetched. Parsing existing subscription keys...');
    }
    const existing_key = pushSubscription?.options?.applicationServerKey ?? null;
    const new_key = urlBase64ToUint8Array(applicationServerKey).buffer;
    const applicationServerKeys = await Promise.all([
        convertToBase64(existing_key),
        convertToBase64(new_key),
    ]);
    if (pushSubscription != null && _.uniq(applicationServerKeys).length > 1) {
        swlog('Unsubscribing from current push notifications...');
        const unsub = pushSubscription.unsubscribe();
        pushSubscription = null;
        await unsub;
    }
    let sub = null;
    if (pushSubscription) {
        swlog('Fetching canonical subscription...');
        sub = await swRegistration.pushManager?.getSubscription();
    }
    swlog('Subscribing to push notifications...');
    pushSubUploadRequired = true;
    if (!sub) {
        sub = await swRegistration.pushManager?.subscribe({
            userVisibleOnly: true,
            applicationServerKey: urlBase64ToUint8Array(applicationServerKey),
        });
    }
    pushSubscription = sub;
    if (Notification.permission !== 'granted') {
        await emptyPromise();
    }
    else if (pushSubUploadRequired) {
        await uploadPushSubscription();
    }
    else {
        await checkPushSubscription();
    }
    if (Notification.permission === 'granted') {
        swlog('TriOnline Installation Complete');
    }
    else {
        swlog('TriOnline Installation Complete - No Notifications');
    }
};
const uploadPushSubscription = async () => {
    new Promise(resolve => {
        if (!pushSubscription) {
            throw new Error('No push subscription to upload');
        }
        swlog('Registering push subscription with server...');
        trionlineAjax({
            url: '/api/push/register/',
            method: 'post',
            data: {
                data: JSON.stringify(pushSubscription.toJSON()),
                UA: navigator?.userAgent ?? null,
            },
            yes: () => {
                resolve();
            },
            no: () => {
                console.error('Failed to upload push subscription');
                pushSubscription?.unsubscribe();
            },
        });
    });
};
const askPermissionNotifications = async () => {
    const is_already_granted = Notification.permission === 'granted';
    const is_push_enabled = window.rootData?.PushEnabled ?? false;
    if (!is_already_granted && !is_push_enabled) {
        return 'denied';
    }
    if (Notification.permission === 'granted') {
        return 'granted';
    }
    if (Notification.permission === 'denied') {
        return 'denied';
    }
    return askUserForNotificationPermission();
};
const askUserForNotificationPermission = async () => {
    swlog('Requesting push notification permission...');
    return new Promise((res, rej) => reactFlyoutNew(null, [380, 220], {
        tag: RequestNotificationForm,
        resolvePromise: res,
        rejectPromise: rej,
    }));
};
const getSubscription = async () => {
    if (Notification.permission !== 'granted') {
        return null;
    }
    swlog('Requesting push subscription information...');
    return swRegistration?.pushManager?.getSubscription();
};
const getApplicationServerKey = async () => new Promise((resolve, reject) => trionlineAjax({
    url: '/vapid/',
    yes: app_key => {
        resolve(app_key);
    },
    no: e => {
        reject(e);
    },
}));
const urlBase64ToUint8Array = (base64String) => {
    const padding = '='.repeat((4 - (base64String.length % 4)) % 4);
    const base64 = (base64String + padding).replace(/\-/g, '+').replace(/_/g, '/');
    const rawData = window.atob(base64);
    const outputArray = new Uint8Array(rawData.length);
    _.range(0, rawData.length).forEach(i => {
        outputArray[i] = rawData.charCodeAt(i);
    });
    return outputArray;
};
const convertToBase64 = async (buffer) => new Promise(resolve => {
    if (buffer == null) {
        resolve(null);
    }
    const reader = new FileReader();
    reader.addEventListener('loadend', e => {
        const text = e.target.result;
        resolve(text);
    });
    reader.readAsText(new Blob([new Uint8Array(buffer)]));
});
export const clearServiceWorkerCache = async () => {
    const x = await sendServiceWorkerMessage({ type: 'clear-cache' });
    swlog('Sent', x);
};
export const cacheFileServiceWorker = async (url, blob64, mime, force_dl, cb) => {
    const args = {
        type: 'add-to-cache',
        url,
        blob64,
        mime,
        force_dl,
    };
    try {
        await sendServiceWorkerMessage(args);
        cb();
        return;
    }
    catch (x) {
        console.error('Failed', x);
        return;
    }
};
export const cacheFileServiceWorkerPromise = async (url, blob64, mime, force_dl) => new Promise(resolve => {
    cacheFileServiceWorker(url, blob64, mime, force_dl, () => {
        resolve();
    });
});
export const viewCachedFiles = async () => new Promise(async (resolve) => {
    const x = await sendServiceWorkerMessage({ type: 'view-cache' });
    resolve(JSON.parse(x));
});
export const viewCachedFilesTable = async () => {
    const data = await viewCachedFiles();
    console.table(_.sortBy(data, (x) => x.size));
    swlog(String(_.sumBy(data, (x) => x.size)));
};
const sendServiceWorkerMessage = async (msg) => new Promise((resolve, reject) => {
    const msgChan = new MessageChannel();
    msgChan.port1.onmessage = ev => {
        if (ev.data.error) {
            reject(ev.data.error);
            return;
        }
        resolve(ev.data);
    };
    return navigator.serviceWorker.controller?.postMessage(msg, [msgChan.port2]);
});
export const unsubscribe = async () => {
    const sub = await getSubscription();
    if (sub) {
        const success = await sub.unsubscribe();
        if (success) {
            swlog('Unsubscribed from push notifications');
        }
        else {
            swlog('Error unsubscribing from push notifications');
        }
    }
};
const checkPushSubscription = async () => {
    const endpoints = await getExistingPushEndpoints();
    if (endpoints == null) {
        swlog('Push subscriptions disabled - unavailable');
    }
    else if (endpoints.indexOf(pushSubscription?.endpoint) === -1) {
        swlog('Requesting a new subscription');
        await requestNewPushSubscription();
    }
};
const getExistingPushEndpoints = async () => new Promise((resolve, reject) => {
    const existing = window.rootData?.PushEndpoints;
    if (existing != null) {
        resolve(existing);
        return;
    }
    trionlineAjax({
        url: '/api/push/get/',
        no: x => {
            reject(x);
        },
        yes: x => {
            try {
                const endpoints = JSON.parse(x);
                resolve(endpoints);
            }
            catch (error) {
                console.warn('No push registrations available - server unreachable');
                resolve(null);
            }
        },
    });
});
const requestNewPushSubscription = async () => {
    const sub = await getSubscription();
    await sub?.unsubscribe();
    await swRegistration.pushManager?.subscribe({
        userVisibleOnly: true,
        applicationServerKey: urlBase64ToUint8Array(applicationServerKey),
    });
    pushSubscription = sub;
    await uploadPushSubscription();
};
const emptyPromise = async () => new Promise((x) => x());
class RequestNotificationForm extends React.Component {
    constructor(props) {
        super(props);
        Bindings(this, [this.accept, this.reject]);
        this.state = { accepting: false };
    }
    render() {
        return j2r(() => {
            if (this.state.accepting) {
                return this.buildDirectionalPrompt();
            }
            return this.buildSalesPitch();
        });
    }
    buildSalesPitch() {
        return {
            children: [
                {
                    tag: 'p',
                    key: 'desc',
                    text: `\
We'd like to send you notifications about updates to your roster. \
Some urgent notifications may be sent via SMS instead. If you do \
not wish to receive push notifications from TriOnline, you will need \
to check this app periodically for updates instead.\
`,
                },
                {
                    cl: 'buttons cntr',
                    key: 'buttons',
                    children: [
                        {
                            tag: J2rButton,
                            key: 'agree',
                            label: 'Agree',
                            type: 'submit',
                            onClick: this.accept,
                        },
                        {
                            tag: J2rButton,
                            key: 'disagree',
                            label: 'Disagree',
                            type: 'standard',
                            onClick: this.reject,
                        },
                    ],
                },
            ],
        };
    }
    buildDirectionalPrompt() {
        return {
            tag: 'p',
            key: 'ty-text',
            text: `\
Thank you. Your browser / device should now be prompting you to accept. \
Click or tap on "Allow" to complete this one-time process.\
`,
        };
    }
    async accept() {
        swlog('Presenting browser confirmation prompt for push notifications');
        await this.askViaBrowser();
        this.setState({ accepting: true });
    }
    reject() {
        swlog('Rejecting push notifications for now');
        this.props.resolvePromise('denied');
        this.props.flyout.Close();
    }
    async askViaBrowser() {
        const permissionResult = await Notification.requestPermission();
        this.props.resolvePromise(permissionResult);
        this.props.flyout.Close();
    }
}
//# sourceMappingURL=component-sw-client.js.map